<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-item :label="$t('设备ID')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['deviceId']" :placeholder="$t('请输入设备ID')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('设备类型')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['deviceType']" :placeholder="$t('请输入设备类型')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('单位')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['deptId']" :placeholder="$t('请输入单位')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('安装位置')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['deviceLocation']" :placeholder="$t('请输入安装位置')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('联网状态')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag v-decorator="['deviceNetworkedStatus']" :placeholder="$t('请输入联网状态')" :triggerChange="true" dictCode="wq_device_networked_status" style="width:100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('经度')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['longitude']" :placeholder="$t('请输入经度')" :min="1" :max="100" style="width:100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('纬度')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['latitude']" :placeholder="$t('请输入纬度')" :min="1" :max="100" style="width:100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('校验标准')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select v-decorator="['standardId']" :placeholder="$t('请选择校验标准')">
                <a-select-option v-for="data in CalibrationStandard" :key="data.id" :value="data.id">
                  {{data.batchNo}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('备注')" style="width:95%">
              <a-textarea
                v-decorator="['remark']"
                :placeholder="$t('请输入备注信息')"
                :auto-size="{ minRows: 3, maxRows: 5 }"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'  
  import { listSize } from '@/utils/util'

  export default {
    name: 'WqDeviceForm',
    components: {
      JFormContainer,
      JDate,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        CalibrationStandard:[], //校验标准
        validatorRules: {
        },
        url: {
          add: "/wq/wQDevice/add",
          edit: "/wq/wQDevice/edit",
          queryById: "/wq/wQDevice/queryById",
          CalibrationStandard: "/wq/wQCheckBaseStandard/list",
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
      this.queryCalibrationStandard();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'deviceType','deptId','deviceId','deviceLocation','deviceNetworkedStatus','standardId','longitude','latitude','remark'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit(res.result);
            }
          });
        }
      },
      queryCalibrationStandard() {
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.CalibrationStandard, params).then((res) => {
          if(res.success){
            this.CalibrationStandard = res.result.records;
            console.log(this.CalibrationStandard);
          }
        }) 
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'deviceType','deptId','deviceId','deviceLocation','deviceNetworkedStatus','standardId','longitude','latitude','remark','createBy','createTime','updateBy','updateTime'))
      },
      // changeDeviceNetworkedStatus(e) {
      //   console.log(e)
      //   this.formModel.deviceNetworkedStatus = e
      // },
    }
  }
</script>